export default "__VITE_ASSET__021186ae__"